import { createFileRoute } from '@tanstack/react-router';

import { InventoryCatalog } from '../modules/Inventory/main';

export const Route = createFileRoute('/requisition-catalog')({
  component: RouteComponent,
  head(ctx) {
    return {
      meta: [{ title: 'Inventory Catalog' }],
    };
  },
});

function RouteComponent() {
  return (
    <div className="container mx-auto p-6">
      <div className="mb-6">
        <h1 className="text-3xl font-bold">Inventory Catalog</h1>
        <p className="text-muted-foreground mt-2">
          Browse available items and create new requisitions
        </p>
      </div>
      <InventoryCatalog />
    </div>
  );
}
